var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resizable-overlay layout-grid presentation",class:{ 'has-back-stage': _vm.$auth.ADMIN },on:{"mouseleave":_vm.clearResize}},_vm._l((12),function(i){return _c('ResizeColumn',{key:i,attrs:{"idx":i},on:{"clearResize":_vm.clearResize}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }